(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lotus-landing-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SLIDE_INTERVAL = 3000;

    function initSlideshow(sectionEl) {
      var slideshowEl = sectionEl.querySelector('.lotus-lhero__slideshow');
      if (!slideshowEl) return;

      var slides = Array.from(slideshowEl.querySelectorAll('.lotus-lhero__slide'));
      var pagBars = Array.from(slideshowEl.querySelectorAll('.lotus-lhero__pag-bar'));
      if (slides.length <= 1) return;

      var current = 0;
      var timer = null;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        pagBars[current].classList.remove('is-active');
        pagBars[current].setAttribute('aria-selected', 'false');

        current = index;

        slides[current].classList.add('is-active');
        pagBars[current].classList.add('is-active');
        pagBars[current].setAttribute('aria-selected', 'true');
      }

      function advance() {
        goTo((current + 1) % slides.length);
      }

      function startTimer() {
        clearInterval(timer);
        timer = setInterval(advance, SLIDE_INTERVAL);
      }

      function stopTimer() {
        clearInterval(timer);
        timer = null;
      }

      pagBars.forEach(function (bar, i) {
        bar.addEventListener('click', function () {
          stopTimer();
          goTo(i);
          startTimer();
        });
      });

      startTimer();

      document.addEventListener('shopify:section:unload', function (e) {
        if (e.target && e.target.contains(sectionEl)) stopTimer();
      });
    }

    function initGsap(sectionEl) {
      var prefersReduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function run() {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
        gsap.registerPlugin(ScrollTrigger);

        var targets = Array.from(sectionEl.querySelectorAll('.js-lhero-anim'));
        if (!targets.length) return;

        if (prefersReduced) {
          gsap.set(targets, { opacity: 1, y: 0 });
          return;
        }

        gsap.set(targets, { opacity: 0, y: 20, willChange: 'transform,opacity' });

        ScrollTrigger.batch(targets, {
          start: 'top 88%',
          once: true,
          onEnter: function (batch) {
            gsap.to(batch, {
              opacity: 1,
              y: 0,
              duration: 0.9,
              ease: 'power2.out',
              stagger: 0.1,
              overwrite: 'auto',
              clearProps: 'willChange',
            });
          },
        });

        setTimeout(function () {
          if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
        }, 300);
      }

      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        run();
      } else {
        setTimeout(run, 300);
      }
    }

    function initSection(sectionEl) {
      if (!sectionEl) return;
      initSlideshow(sectionEl);
      initGsap(sectionEl);
    }

    function findAndInit(root) {
      (root || document)
        .querySelectorAll('.lotus-lhero[data-section-id]')
        .forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { findAndInit(document); });
    } else {
      findAndInit(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      var sectionEl = e.target && e.target.querySelector('.lotus-lhero[data-section-id]');
      if (sectionEl) initSection(sectionEl);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
